import { useEffect, useState } from "react";
import { Activity, Boxes, Receipt, Ticket, Users } from "lucide-react";
import { AppShell } from "@/components/AppShell";
import { adminService } from "@/services/adminService";
import { ADMIN_NAV } from "./nav";

const Card = ({ label, value, icon: Icon, testId, hint }) => (
  <div data-testid={testId}
       className="rounded-md border border-[#22252F] bg-[#12141A] p-6 transition-colors hover:border-[#2563EB]/40">
    <div className="flex items-center justify-between">
      <p className="text-[11px] uppercase tracking-[0.2em] text-[#94A3B8]">{label}</p>
      <Icon className="h-4 w-4 text-[#60A5FA]" />
    </div>
    <p className="mt-6 font-mono text-2xl text-white">{value}</p>
    {hint ? <p className="mt-2 text-xs text-[#4B5563]">{hint}</p> : null}
  </div>
);

export default function AdminDashboardPage() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    adminService.stats().then(setStats).catch(() => setStats(null));
  }, []);

  return (
    <AppShell nav={ADMIN_NAV} title="Painel Administrativo" subtitle="Estado geral da plataforma">
      <div data-testid="admin-dashboard" className="space-y-10">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-4">
          <Card testId="admin-stat-total-users" label="Total de utilizadores" value={stats?.total_users ?? "—"} icon={Users} />
          <Card testId="admin-stat-active-users" label="Utilizadores ativos" value={stats?.active_users ?? "—"} icon={Users} />
          <Card testId="admin-stat-assets" label="Total de ativos" value={stats?.total_assets ?? "—"} icon={Boxes}
                hint="Etapa 5" />
          <Card testId="admin-stat-trades" label="Total de operações" value={stats?.total_trades ?? "—"} icon={Receipt}
                hint="Etapa 12" />
          <Card testId="admin-stat-providers" label="Provedores" value={stats?.providers ?? "—"} icon={Activity}
                hint="Etapa 6" />
          <Card testId="admin-stat-codes" label="Códigos ativos" value={stats?.active_invite_codes ?? "—"} icon={Ticket} />
          <Card testId="admin-stat-price-engine" label="Price Engine"
                value={stats?.price_engine_status === "on" ? "ON" : "OFF"} icon={Activity}
                hint={stats?.price_engine_status === "on" ? "daemon ativo" : "daemon parado"} />
          <Card testId="admin-stat-cache" label="Preços em cache"
                value={stats?.cached_symbols ?? "—"} icon={Activity} hint="símbolos" />
        </div>

        <section className="rounded-md border border-[#22252F] bg-[#12141A] p-8">
          <p className="text-xs uppercase tracking-[0.2em] text-[#60A5FA]">Ordem oficial de desenvolvimento</p>
          <ol className="mt-6 grid grid-cols-1 gap-2 font-mono text-xs text-[#94A3B8] sm:grid-cols-3">
            {[
              "1 Estrutura Base ✓", "2 Banco de Dados ✓", "3 Autenticação e Users ✓",
              "4 Administrator Panel ·", "5 Asset Management", "6 Provider Management",
              "7 API Keys e Fallback", "8 Market Data Providers", "9 Price Engine",
              "10 Cache e Data Storage", "11 Internal WebSocket", "12 Paper Trading",
              "13 Portfolio e Trade Ledger", "14 Security Review", "15 Testing e Finalização",
            ].map((s) => (
              <li key={s} className="border border-[#22252F] px-3 py-2">{s}</li>
            ))}
          </ol>
        </section>
      </div>
    </AppShell>
  );
}
